module.exports = __webpack_public_path__ + "static/seal-black-0116718d33056a6f8c255fe1860c8ee0.svg";